export enum SectionType {
  HEADLINE = 'headline',
  ANNOUNCEMENT = 'announcement',
  CONTACT = 'contact',
  STAGE = 'stage',
  INFO = 'info',
  HERO = 'hero',
  HERO_1 = 'hero_1',
  HERO_2 = 'hero_2',
  HERO_3 = 'hero_3',
  EQUAL_3 = 'equal_3',
  TOP_3 = 'top_3',
  EQUAL_4 = 'equal_4',
  SQUARE = 'square',
  STAGGERED = 'staggered',
  CAROUSEL = 'carousel',
  EVENT_RIBBON = 'event_ribbon',
  TEST_CAR = 'test_car',
  TEST_ROUTE = 'test_route',
  AGENDA = 'agenda',
  EVENT_REGISTRATION = 'event_registration',
  EVENT_CONTACTS = 'event_contacts',
  EVENT_EXPERTS = 'event_experts',
  HIGHLIGHT = 'highlight',
  PRESSKIT = 'presskit',
  DYNAMIC = 'dynamic',
}
